import { BaseModel } from '~/models/baseModel';

export class OfferLotLimitModel extends BaseModel  {
    public limit:number;
    public description:string;
}